<template>
    <div class="ds-employees-chips ds-ex-chips">
        <span v-for="chip in chips" :key="chip.key" class="ds-employees-chip">
            <span class="ds-employees-chip-label">{{ chip.label }}</span>
            <button type="button" class="ds-employees-chip-remove" :aria-label="`Убрать фильтр ${chip.label}`" @click="emit('remove', chip.key)">
                <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
            </button>
        </span>
        <button type="button" class="ds-employees-chips-reset" @click="emit('reset')">Сбросить всё</button>
        <span v-if="foundText" class="ds-employees-chips-found" aria-live="polite">{{ foundText }}</span>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

export interface ExchangeChip {
    key: string
    label: string
}

// found/total — matched_count/total_in_period из summary; без summary — без ложных чисел.
const props = defineProps<{ chips: ExchangeChip[], found: number | null, total: number | null }>()
const emit = defineEmits<{ remove: [key: string], reset: [] }>()

const foundText = computed(() => {
    if (props.found === null) return ''
    const n = props.found.toLocaleString('ru-RU')
    return props.total === null ? `Найдено ${n}` : `Найдено ${n} из ${props.total.toLocaleString('ru-RU')}`
})
</script>
